import React, { useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
} from "reactstrap";
import { employeeStatusLabels, EMPLOYEE_STATUS } from "../../../constants";
import { updateEmployeeStatus } from "../../../slices/admin/thunk";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

const EditStatusEmployeeModal = ({ item, open, setOpen, onRefreshTable }) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState();

  useEffect(() => {
    setStatus(item?.status);
  }, [item]);

  const toggleModalInfoUser = () => {
    setOpen(!open);
  };

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  const handleUpdateStatus = async () => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to change the status of this employee?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Processing...",
            html: "Please wait",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          const response = await dispatch(
            updateEmployeeStatus({
              employeeId: item.id,
              status,
            })
          );

          if (response) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Employee status updated successfully",
            });
            onRefreshTable();
            toggleModalInfoUser();
          }
        }
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
      });
    }
  };

  return (
    <Modal isOpen={open} toggle={toggleModalInfoUser}>
      <ModalHeader toggle={toggleModalInfoUser}>Edit Status</ModalHeader>
      <ModalBody>
        <select
          className="form-select"
          value={status}
          onChange={handleStatusChange}
        >
          {Object.values(EMPLOYEE_STATUS).map((status) => (
            <option key={status} value={status}>
              {employeeStatusLabels[status]}
            </option>
          ))}
        </select>
      </ModalBody>
      <Row>
        <Col className="col-6">
          <Button
            color="soft-primary"
            className="border border-primary w-100"
            onClick={toggleModalInfoUser}
          >
            Cancel
          </Button>
        </Col>
        <Col className="col-6">
          <Button
            color="primary"
            disabled={status === item?.status}
            className="btn btn-primary w-100"
            onClick={handleUpdateStatus}
          >
            Save
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default EditStatusEmployeeModal;
